const commonHr = {
    "restaurant": "Restoran",
    "restaurant_not_found": "Restoran nije dostupan",
    "table_not_available": "Narudžbe se ne mogu izvršiti za ovim stolom",
    "note": "Bilješka",
    "order": "Redoslijed",
    "internal_error": "Zahtjev nije uspio. Poslužitelj je odgovorio sljedećom greškom:",
    "no_results": "Nema rezultata",
    "cancel": "Otkazati",
    "save": "Uštedjeti",
    "back": "Nazad",
    "search": "Pretraživanje",
    "search_for_file_names": "Pretraživanje naziva datoteka",
    "delete": "Izbrisati",
    "search_by_restaurant": "Pretraživanje po restoranu",
    "available": "Dostupno",
    "unavailable": "Nije dostupno",
    "name": "Ime",
    "status": "Status",
    "description": "Opis",
    "price": "Cijena",
    "add": "Dodati",
    "phone": "Telefon",
    "internal_server_error": "Interna pogreška poslužitelja",
    "remove_all": "Obriši sve",
    "settings": "Postavke",
    "restaurant_name": "Naziv restorana",
    "reservation_link": "Veza za rezervaciju",
    "reservation_link_tooltip": "Dopuštene su samo poveznice na sustav rezervacija Reservours",
    "add_user": "Dodaj korisnika",
    "add_user_title": "Omogućite pristup restoranu",
    "restaurant_users": "Korisnici s pristupom restoranu",
    "restaurant_description_hu": "Opis restorana (mađarski)",
    "restaurant_description_en": "Opis restorana (engleski)",
    "changes_saved": "Promjene su uspješno spremljene",
    "user_added_to_restaurant": "Korisniku je odobren pristup restoranu",
    "user_add_to_restaurant_tip": "Korisnik s navedenom adresom e-pošte dobit će pristup odabranom restoranu. Ako korisnik još nema račun, automatski će dobiti pristup nakon registracije.",
    "sign_up_here": "Ovdje možete kreirati račun",
    "role_already_exists": "Korisnik s ovom e-mail adresom već ima pristup restoranu",
    "error": "Pogreška",
    "header_image": "Zaglavna slika",
    "upload_image": "Prenesi sliku",
    "image_not_set": "Slika nije postavljena",
    "validation": {
        "required": "Ovo polje je obavezno",
        "optional": "Ovo polje je opcionalno"
    },
    "hungary": "Mađarska",
    "date": "Datum",
    "close": "Zatvoriti",
    "continue": "Nastaviti",
    "select_image": "Odaberite sliku",
    "grant": "Grant",
    "restaurant_settings": "Postavke restorana",
    "create_restaurant": "Izradi restoran",
    "restaurant_created": "Restoran je uspješno kreiran",
    "restaurant_created_text": "Vaš je restoran uspješno kreiran. Sada možete dodavati stavke jelovnika i upravljati postavkama restorana.",
    "continue_to_menu": "Nastavite s uređivanjem izbornika",
    "languages": {
        "hu": "Mađarski",
        "en": "engleski",
        "de": "njemački",
        "fr": "francuski",
        "sk": "slovački",
        "cz": "češki",
        "pl": "Polirati",
        "si": "slovenski",
        "hr": "hrvatski",
        "ro": "Rumunjski"
    },
    "no_file_selected": "Nije odabrana datoteka",
    "max_file_size": "Maksimalna veličina datoteke:",
    "language": "Jezik",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Facebook piksel",
    "analytic_integration_premium_feature": "Integracija analitike dio je PRO plana",
    "refresh": "Osvježiti",
    "address": "Adresa",
    "city": "Grad",
    "postal_code": "Poštanski broj",
    "timezone": "Vremenska zona",
    "country": "Zemlja",
    "currency": "Valuta",
    "currency_tooltip": "Ovo je potrebno samo za postavke profila, naš sustav neće obavljati financijske transakcije u vaše ime",
    "or": "ili"
};

export default commonHr;
